import React from 'react'

import { SpecificChartFunctionality } from '../../constants/common'
import { useModelState } from '../../model-hooks/use-model-state'
import ChartLayout from '../../models/chart_layout'
import { getIsDrawingEnabledOnQuotePage } from '../../utils'

export function useIsAutoSaveActive(chartLayout: ChartLayout) {
  const chartLayoutModel = useModelState(chartLayout, {
    watchProperties: ['isInit', 'isPreserveDrawingsActive', 'idea'],
  })
  const { specificChartFunctionality, idea, isInit, isPreserveDrawingsActive } = chartLayoutModel
  return React.useMemo(() => {
    if (!window.FinvizSettings.hasUserPremium) {
      return false
    }

    let isPageWithDrawings = false
    if (specificChartFunctionality === SpecificChartFunctionality.chartPage) {
      isPageWithDrawings = true
    } else if (specificChartFunctionality === SpecificChartFunctionality.quotePage) {
      isPageWithDrawings = getIsDrawingEnabledOnQuotePage()
    }

    return isPageWithDrawings && isPreserveDrawingsActive && !!isInit && !idea?.id
  }, [specificChartFunctionality, isPreserveDrawingsActive, isInit, idea?.id])
}
